<template>
	<a :href="`https://rugcheck.xyz/tokens/${mint}`" target="_blank" class="widget-container d-inline-block animate__animated animate__fadeIn small"
			v-if="report"
			@mouseenter="hover=true"
			@mouseleave="hover=false"
			:class="{'hovering' :
	hover}">
		<div class="overview">
			<img title="Rugcheck Report" alt="RugCheck.xyz" src="/images/socials/rugcheck.png" class="logo">
			<span class="d-inline-block text-center mx-2 score animate__animated animate__fadeIn" style="flex-grow: 1" :key="title">{{ title }}</span>
		</div>
		<div class="risks" :style="riskView">
			<div class="list small text-center my-2">
				<code class="d-block mb-0" v-for="(risk,key) in report.risks" :key="key" :class="{
				'text-danger': risk.level === 'danger',
				'text-warning': risk.level === 'warn',
			}">{{ risk.name }}</code>
			</div>
		</div>
	</a>
</template>

<script>
export default {
	name: "RugWidget",
	props: {
		mint: {
			required: true
		}
	},
	data() {
		return {
			hover: false,
			report: null,
			interval: null
		}
	},
	watch: {
		mint: function () {
			this.report = null
			this.fetchReport()
		}
	},
	computed: {
		riskView: function () {
			if (this.hover && this.report?.risks?.length > 0)
				return {maxHeight: "200px"}

			return {maxHeight: "0"}
		},
		riskLevel: function () {
			if (this.report.score < 1000)
				return "✅"

			if (this.report.score < 5000)
				return "⚠️"

			return "❌"
		},
		title: function () {
			if (this.hover && this.report?.risks?.length > 0)
				return `Risks`

			if (this.report?.error) {
				if (this.report?.error.indexOf("limit") > 0)
					return "Rate Limited"

				return this.report?.error
			}

			return `${this.report.score.toLocaleString()} ${this.riskLevel}`
		}
	},
	methods: {
		fetchReport: function () {
			const whitelist = {
				"So11111111111111111111111111111111111111112": true,
				"EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v": true,
				"Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB": true,
				"USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX": true,
				"mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So": true,
				"7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj": true,
				"J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn": true,
				"bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1": true,
			}

			if (whitelist[this.mint]) {
				this.report = {score: 0, risks: []}
				return
			}

			this.$store.state.solana.rugCheckClient.summary(this.mint).then(r => {
				this.report = r
			}).catch(e => {
				console.error("Failed to fetch report for", this.mint, e)
				this.report = null

				this.interval = setTimeout(() => {
					if (this.report && !this.report.error) {
						clearTimeout(this.interval)
						return
					}
					this.fetchReport()
				}, 40000)
			})
		},
		color: function () {
			let color = "red"
			switch (this.riskLevel) {
				case "✅":
					return "green";
				case "⚠️":
					return "darkorange";
				case "❌":
					return "red";
			}
			return color
		},
	},
	beforeMount() {
		this.fetchReport()
	},
	beforeDestroy() {
		clearTimeout(this.interval)
	}
}
</script>

<style scoped>
.widget-container {
	text-decoration: none;
	cursor: pointer;
	background: black;
	border: 1px solid white;
	border-radius: 10px;
	min-width: 115px;

	border-top-right-radius: 0;
	border-bottom-left-radius: 0;
}

.overview {
	text-align: start;
	display: flex;
	align-items: center;
	align-content: center;
}

.hovering .overview {
	border-bottom: unset;
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

img {
	outline: 1px solid white;
}

.score {
	font-size: 1rem;
	color: white;
}

.risks {
	overflow: hidden;
	transition: all 0.6s linear;
	cursor: pointer;
}

.risks .list {
	overflow: hidden;
	transition: max-height 0.25s ease-in;
}

code {
	background: black;
}

.logo {
	height: 32px;
	border-bottom-right-radius: 15px;
	border-top-left-radius: 7px;
}
</style>